import React from 'react'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'

const ResetOnChange: React.FC<{ name: string; fields: any[]; setTo?: any }> = ({ name, fields = [], setTo = '' }) => (
  <>
    {fields.map(({ fieldName, resetFunction = () => null }) => (
      <Field key={fieldName} name={fieldName} subscription={{}}>
        {({ input: { onChange } }) => (
          <OnChange name={name}>
            {() => {
              resetFunction()
              onChange(setTo)
            }}
          </OnChange>
        )}
      </Field>
    ))}
  </>
)

export default ResetOnChange
